import React from "react"
import {
    StyleSheet,
    Text,
    View,
    RefreshControl,
    ScrollView
} from "react-native"

import { OrderContext } from '../../contexts/order/Store';
import { Ionicons as Icon } from '@expo/vector-icons';
import FontStyles from "../../constants/FontStyle";
import Colors from "../../constants/Colors";

import { AnalyticsService } from "../../constants/Analytics";
import { FlatList } from "react-native-gesture-handler";

import OrderGroupCard from '../../components/order/OrderGroupCard';
import { useNavigation } from "@react-navigation/native";
import StyledIcon from "../../components/StyledIcon";

const analytics = new AnalyticsService()

function OrderListPendingScreen() {
    const navigation = useNavigation()

    const { state: order_state } = React.useContext(OrderContext)

    const RenderItem = ({ order }) => {
        return <OrderGroupCard navigation={navigation} order={order.item} />
    }
    const [refresh, setRefresh] = React.useState(false)
    const onRefresh = () => {
        setRefresh(true)
        order_fetch().then(() => {
            setRefresh(false)
        }).catch(() => {
            setRefresh(false)
        })
    }

    return (
        <>
            {
                order_state.order_group_pending &&
                    order_state.order_group_pending.length
                    ? <FlatList
                        initialNumToRender={3}
                        data={order_state.order_group_pending}
                        renderItem={item => <RenderItem order={item} />}
                        keyExtractor={item => `${item._id}`}
                        contentContainerStyle={styles.container}
                        refreshControl={
                            <RefreshControl
                                refreshing={refresh}
                                onRefresh={() => onRefresh()}
                            />}
                    />
                    : <ScrollView
                        contentContainerStyle={styles.emptyContainer}
                        refreshControl={
                            <RefreshControl
                                refreshing={refresh}
                                onRefresh={() => onRefresh()}
                            />}
                    >
                        <StyledIcon
                            iconName='shopping-bag'
                            iconColor={Colors.shades._1}
                            iconLibrary='Feather'
                            iconOnly
                            size={58}
                        />
                        <Text style={{
                            ...FontStyles.dark,
                            ...FontStyles.size16,
                            ...FontStyles.lh20,
                            ...FontStyles.bold,
                            textAlign: 'center',
                            marginTop: 8
                        }}>No pending order</Text>
                        <Text style={{
                            color: Colors.shades._7,
                            ...FontStyles.size13,
                            ...FontStyles.lh18,
                            ...FontStyles.normal,
                            textAlign: 'center',
                            marginTop: 10
                        }}>You have not placed any order.</Text>
                    </ScrollView>
            }
        </>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: Colors.shades._5,
        paddingBottom: 100
    },
    emptyContainer: {
        flexGrow: 1,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 16,
        backgroundColor: Colors.whiteColor
    }
})

export default OrderListPendingScreen